import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import styles from "./ProjectCard.module.css";
import shop from "../../images/shop.svg";
import port from "../../images/port.svg";
import link from "../../images/link.svg";
import draw from "../../images/draw.svg";
import not from "../../images/not.svg";
// import room from "../../images/room.svg";

function HexagonCard({
  imgName,
  projectName,
  view,
  code,
  showCode,
  showProject,
}) {
  let image = shop;
  switch (imgName) {
    case "img1":
      image = shop;
      break;
    case "img2":
      image = port;
      break;
    case "img3":
      image = link;
      break;
    case "img4":
      image = draw;
      break;
    case "img5":
      image = not;
      break;
    case "img6":
      image = not;
      break;
    default:
      image = not;
      break;
  }
  return (
    <div className={styles.card}>
      <p className={styles.arrow}>
        <ArrowBackIosIcon
          className={styles.cardArrow}
          style={{ fontSize: "3.5vw", color: "aliceblue" }}
        />
      </p>
      <div className={styles.division}>
        <img
          // src="https://www.truepush.com/blog/wp-content/uploads/2019/10/project.jpg"
          src={image}
          alt=""
          className={styles.cardImage}
        />
        <div className={styles.image__overlay}>
          <div className={styles.projectName}>{projectName}</div>
          <div
            className={`${styles.seeProject} ${
              !showProject && styles.dontShowParent
            }`}
          >
            <a
              href={view}
              target="_blank"
              rel="noreferrer"
              className={`${!showProject && styles.dontShow}`}
            >
              View Project
            </a>
          </div>
          <div
            className={`${styles.sourceCode} ${
              !showCode && styles.dontShowParent
            }`}
          >
            <a
              href={code}
              target="_blank"
              rel="noreferrer"
              className={`${!showCode && styles.dontShow}`}
            >
              Source Code
            </a>
          </div>
        </div>
      </div>
      <p className={styles.arrow}>
        <ArrowForwardIosIcon
          className={styles.cardArrow}
          style={{ fontSize: "3.5vw", color: "aliceblue" }}
        />
      </p>
    </div>
  );
}

export default HexagonCard;
